import React, { useEffect, useState } from 'react'
import { Button, Empty, NavBar, Toast } from 'antd-mobile';
import { CalendarOutline, LocationOutline, EnvironmentOutline, RightOutline } from 'antd-mobile-icons';
import { useNavigate } from 'react-router-dom';
import '../index.css';
import { useAuth } from '../../app/providers/AuthProvider';
import { gameYearApi } from '../../features/game-year/api/gameYearApi';
export default function GameYearList() {

    const [gameYearList, setGameYearList] = useState([]);

    const navigate = useNavigate();

    const { memberInfo } = useAuth();

    useEffect(() => {
        gameYearApi.getList()
            .then(function (response) {
                const resultData = response.data.data;
                setGameYearList(resultData);
                Toast.clear();
            })
            .catch(function (error) {
                Toast.show({
                    icon: 'fail',
                    content: '查询失败，请联系管理员！'
                });
            })
            .finally(() => {
                Toast.clear();
            });
    }, []);


    return (
        <div className="game-year-container has-unified-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                年会活动列表
            </NavBar>
            <div style={{ padding: '16px 10px' }}>
                {memberInfo.admin === 1 &&
                    <Button block className="create-activity-btn" onClick={() => {
                        navigate('/gameYearCreate');
                    }}>
                        ＋ 创建年会活动
                    </Button>
                }
                {
                    gameYearList?.length > 0 ?
                        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
                            {gameYearList?.map((yearGame, index) => (
                                <div key={yearGame.id} className="year-event-card" onClick={() => {
                                    navigate(`/game-years/${yearGame.id}`);
                                }}>
                                    <div className={`year-event-tag year-event-tag--${yearGame.status}`}>
                                        {{ 0: '筹备中', 1: '进行中', 2: '已结束' }[yearGame.status] || '活动'}
                                    </div>
                                    
                                    <div className="year-event-title">{yearGame.gameName}</div>

                                    <div className="year-event-info-section">
                                        <div className="year-event-item">
                                            <CalendarOutline className="year-event-item-icon" />
                                            <div className="year-event-item-content">
                                                <span className="year-event-label">活动时间</span>
                                                <span className="year-event-value">{yearGame.gameTime}</span>
                                            </div>
                                        </div>

                                        <div className="year-event-item">
                                            <LocationOutline className="year-event-item-icon" />
                                            <div className="year-event-item-content">
                                                <span className="year-event-label">比赛场地</span>
                                                <span className="year-event-value">{yearGame.gameAddress}</span>
                                            </div>
                                        </div>

                                        {yearGame.dinnerAddress && (
                                            <>
                                                <div className="year-event-divider"></div>
                                                <div className="year-event-item">
                                                    <EnvironmentOutline className="year-event-item-icon" style={{ color: '#FF7D00' }} />
                                                    <div className="year-event-item-content">
                                                        <span className="year-event-label">聚餐地点</span>
                                                        <span className="year-event-value">{yearGame.dinnerAddress}</span>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>

                                    <div className="year-event-footer">
                                        查看详情 <RightOutline className="year-event-footer-arrow" />
                                    </div>
                                </div>
                            ))}
                        </div>
                        :
                        <Empty description='暂无数据' style={{ height: '80vh' }} />
                }

            </div>
        </div>
    );
}
